module.exports = __webpack_public_path__ + "0f59908cdb6bc2967a9adf44fd388fbf.MP3";